module.exports = __webpack_public_path__ + "static/img/renzhenglianmeng@2x.828f805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/renzhenglianmeng@2x.png
// module id = wTUH
// module chunks = 1 3 4 5 6 7